import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Styling is imported by ui/styles.css, the shared sheet both hosts load.
// Keep this React module safe for the server's native Node imports too.
import { ListEmptyState } from './ListEmptyState';
import { CLEAR_FILTERS_LABEL } from './IssueListFilterNote';
/** One empty-list contract for Team Review and the extension. The host supplies
 * unfiltered counts and the same actions its toolbar uses; no issue is mutated. */
export function IssueListEmptyState({ totalCount, searchQuery = '', hasFilters = false, hiddenFinishedCount = 0, onClearSearch, onClearFilters, onShowAllStatuses, onCreate, isViewOnly = false, createClassName = '', captureArmed = false, error, onRetry, }) {
    const searching = searchQuery.trim().length > 0;
    let title;
    let hint;
    let action;
    let label;
    let create = false;
    if (error) {
        title = error;
        hint = 'Try loading the list again.';
        action = onRetry;
        label = 'Retry';
    }
    else if (totalCount === 0 && !searching && !hasFilters) {
        title = captureArmed ? 'Capture your first issue' : onCreate ? 'Create your first issue' : 'No issues yet';
        hint = captureArmed ? 'Click any element on the page to pin an issue.'
            : isViewOnly || !onCreate ? 'Issues captured by your team will appear here.'
                : 'Capture an element on this page to share feedback with your team.';
        if (!captureArmed && onCreate) {
            action = onCreate;
            label = 'Create';
            create = true;
        }
    }
    else if (hiddenFinishedCount > 0) {
        title = 'No active issues';
        hint = `${hiddenFinishedCount} finished ${hiddenFinishedCount === 1 ? 'issue is' : 'issues are'} hidden by the Active issues view.`;
        action = onShowAllStatuses;
        label = 'Show all statuses';
    }
    else {
        title = searching ? hasFilters ? 'No issues match your search and filters' : 'No issues match your search' : 'No issues match your filters';
        hint = 'Try a different search or adjust your filters.';
        label = searching ? hasFilters ? 'Clear search and filters' : 'Clear search' : CLEAR_FILTERS_LABEL;
        if (searching && hasFilters && onClearSearch && onClearFilters) {
            action = () => { onClearSearch(); onClearFilters(); };
        }
        else {
            action = searching ? onClearSearch : onClearFilters;
        }
    }
    return (_jsx(ListEmptyState, { className: "oq-issue-list-empty", error: !!error, title: title, hint: hint, action: action && _jsxs("button", { type: "button", className: `oq-btn oq-btn--${create ? 'primary' : 'secondary'}${createClassName && create && !isViewOnly ? ` ${createClassName}` : ''}`, onClick: action, disabled: create && isViewOnly, title: create && isViewOnly ? 'View only. You can view issues but not create them.' : undefined, "aria-label": create ? 'Create first issue' : error ? 'Retry loading issues' : undefined, children: [label, create && _jsx("kbd", { className: "oq-list-empty__shortcut", "aria-hidden": "true", children: "C" })] }) }));
}
//# sourceMappingURL=IssueListEmptyState.js.map